export default class GetAsistenciaBySubsede {
  #repository
  constructor(repository) {
    this.#repository = repository
  }

  async execute(idSubSede, fechaIni, fechaFin) {
    try {
      const result = await this.#repository.getAsistenciaBySubsede(idSubSede, fechaIni, fechaFin)
      return result
    } catch (error) {
      console.error('Error al obtener la asistencia por subsede:', error)
      throw error
    }
  }
}
